import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    CircularProgress
} from '@mui/material';
import { isAuthenticated } from "../auth";
import { singleForumPost, update } from "./apiForum";
import { Redirect } from "react-router-dom";
import { getFilesForGroup } from '../file/apiFiles';
import Footer from '../core/Footer';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from 'draft-js-export-html';


class EditForumPost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            body: "",
            error: "",
            user: {},
            loading: false,
            redirectToProfile: false,
            groupId: '',
            allGroupFiles: [],
            filetoLink: '',
            editorState: EditorState.createEmpty()
        };
    }

    init = forumpostId => {
        singleForumPost(forumpostId).then(data => {
            if (data.error) {
                this.setState({ redirectToProfile: true });
            } else {                
                this.setState({
                    id: data.forumpostedBy,
                    title: data.title,
                    body: data.body,
                    groupId: data.postedgroupId,
                    error: "",                    
                    editorState : EditorState.createWithContent(convertFromRaw(JSON.parse(data.body)))
                });
                
                
            }
        });

    };

    convertCommentFromJSONToHTML = (text) => { return stateToHTML(convertFromRaw(JSON.parse(text))) }

    componentDidMount() {
        this.forumpostData = new FormData();
        const forumpostId = this.props.match.params.forumpostId;
        this.init(forumpostId);
        this.setState({ user: isAuthenticated().user });
        getFilesForGroup(this.state.groupId ? undefined : '5e2a5e764175b97d84ec6cae', isAuthenticated().token).then(files => {
            if (files.error) {
                console.log(files.error);
            } else {
                this.setState({
                    allGroupFiles: files
                })
                console.log(files)
            }
        })
    }

    isValid = () => {
        const { title, body } = this.state;
        if (title.length === 0 || body.length === 0) {
            this.setState({ error: "All fields are required", loading: false });
            return false;
        }
        return true;
    };

    handleChange = name => event => {
        let value = "";
        if (name === 'filetoLink') {
            value = event.value
        } else {
            value = event.target.value
        }

        this.setState({ error: "" });

        this.forumpostData.set(name, value);
        this.setState({ [name]: value });
    };

    onChange = (editorState) => this.setState({ editorState });

    clickSubmit = event => {
        event.preventDefault();
        this.setState({ loading: true });

        const rawState = JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent()));

        this.forumpostData.set("body", rawState);

        if (this.isValid()) {
            const forumpostId = this.props.match.params.forumpostId;
            const token = isAuthenticated().token;


            update(forumpostId, token, this.forumpostData).then(data => {
                if (data.error) this.setState({ error: data.error });
                else {
                    this.setState({
                        loading: false,
                        title: "",
                        body: "",
                        filetoLink: '',
                        redirectToProfile: true
                    });
                }
            });
        }
    };

    newPostForm = (title, body, groupId, allGroupFiles, editorState) => (
        <Box component="form" sx={{ mt: 2 }}>
            <TextField
                fullWidth
                label="Title"
                onChange={this.handleChange("title")}
                type="text"
                value={title}
                margin="normal"
                variant="outlined"
            />

            <Box sx={{ my: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Body
                </Typography>
                <Editor
                    editorState={this.state.editorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="editer-content"
                    onEditorStateChange={this.onChange}
                    wrapperStyle={{ border: "2px solid #1976d2", marginBottom: "10px", borderRadius: "4px" }}
                    editorStyle={{ height: "300px", padding: "10px"}}
                />
            </Box>

            <Button
                onClick={this.clickSubmit}
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
            >
                Update Forum Message
            </Button>
        </Box>
    );

    render() {
        const {
            title,
            body,
            redirectToProfile,
            error,
            loading,
            groupId,
            allGroupFiles,
            editorState
        } = this.state;

        if (redirectToProfile) {
            return <Redirect to={`/forumpost/${this.props.match.params.forumpostId}`} />;
        }

        return (
            <>
                <Container>
                    <Typography variant="h4" sx={{ mt: 5, mb: 5 }}>
                        Editing Post
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    {loading && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                            <Box sx={{ textAlign: 'center' }}>
                                <CircularProgress sx={{ mb: 2 }} />
                                <Typography variant="h6">Loading...</Typography>
                            </Box>
                        </Box>
                    )}

                    {this.newPostForm(title, body, groupId, allGroupFiles, editorState)}
                </Container>

                <Footer />
            </>
        );
    }
}

export default EditForumPost;